import React from 'react'
import useAuth from '../../context/auth/useAuth'
import {Row, Col, Nav} from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export default function MenuAdmin() {
	const { t } = useTranslation()
	const {logout} = useAuth()

  	return (
		<>
			<Row>
				<Col xs='12' className='d-flex justify-content-center mt-3 mb-2'>
					<div className='avatar'>
						<div className="img-profile"></div>
					</div>
				</Col>
			</Row>
			<Row>
				<Col className='d-flex justify-content-center align-items-center gap-2'>
					{/* <Link to="/admin/config">
						<img src='/images/config.svg' alt="Config" />
					</Link> */}
					<Link to="/" onClick={logout}>
						<i className="fa-solid fa-arrow-right-from-bracket color-primary"></i>
					</Link>
				</Col>
			</Row>
			<Row style={{ marginTop: '100px'}}>
				<Col className='p-0'>
					<Nav className="flex-column">
						<Nav.Item>
							<Link to="/admin/dashboard" className='nav-link'>
								<img src="/images/menus/home.svg" alt="Home" className='me-3'/>
								{t('menus.home')}
							</Link>
						</Nav.Item>
						<Nav.Item>
							<Link to="/admin/candidates" className='nav-link'>
								<img src="/images/menus/user.svg" alt="Usuarios" className='me-3'/>
								{t('admin.dashboard.candidates')}
							</Link>
						</Nav.Item>
						<Nav.Item>
							<Link to="/admin/schools" className='nav-link'>
								<img src="/images/menus/experiencia.svg" alt="Usuarios" className='me-3'/>
								{t('admin.dashboard.schools')}
							</Link>
						</Nav.Item>
						<Nav.Item>
							<Link to="/admin/multischools" className='nav-link'>
								<img src="/images/menus/experiencia.svg" alt="Usuarios" className='me-3'/>
								{t('admin.dashboard.multiSchools')}
							</Link>
						</Nav.Item>
						<Nav.Item>
							<Link to="/admin/activeprocesses" className='nav-link'>
								<img src="/images/menus/processes.svg" alt="Processes" className='me-3'/>
								{t('admin.dashboard.processes')}
							</Link>
						</Nav.Item>
						<Nav.Item>
							<Link to="/admin/dashboard" className='nav-link'>
								<img src="/images/menus/database.svg" alt="Database" className='me-3'/>
								{t('admin.dashboard.database')}
							</Link>
						</Nav.Item>
						<Nav.Item></Nav.Item>
					</Nav>
			</Col>
			</Row>
		</>
	)
}

